import Modal from "@mui/material/Modal";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";


export default function EmailModal({
  open,
  setOpen,
  weekWinners,
  seasonWinners,
  week,
  year,
  loading,
}) {
  const renderWinners = (winners) => {
    return (
      <div>
        {winners.map((winner, i) => {
          return (
            <div key={i}>
              <div>
                {winner.Player !== "-" ? (
                  <>
                    {winner.Player} - {winner.Stat}
                  </>
                ) : (
                  <>{winner.Stat}</>
                )}
              </div>
              <div><b>{winner.Team}</b>{winner.Week ? <span> - Week {winner.Week}</span> : <></>}</div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderPointWinners = (winners) => {
    return (
      <div>
        {winners.map((winner, i) => {
          return (
            <div key={i}>
            {i === 0 &&
              <div>
                  <>
                    {winner.Stat}
                  </>

              </div>
            }
              <div><b>{winner.Team}</b>{winner.Week ? <span> - Week {winner.Week}</span> : <></>}</div>
            </div>
          );
        })}
      </div>
    );

  }

  const createWeekEmail = () => {
    if (!weekWinners || weekWinners.length === 0) {
      return <></>
    }
    const qbs = weekWinners.filter((winner) => winner.Position === "QB");
    const rbs = weekWinners.filter((winner) => winner.Position === "RB");
    const wrs = weekWinners.filter((winner) => winner.Position === "WR");
    const points = weekWinners.filter(
      (winner) => winner.Position === "Total Points"
    );

    return (
      <>
        <br />

        <div>
          {year} Week {week} Leaders
        </div>
        <br />
        <div>
          <div>High Passer{qbs.length > 1 ? " - TIE!" : ""}</div>
          {renderWinners(qbs)}
        </div>
        <br />
        <div>
          <div>High Rusher{rbs.length > 1 ? " - TIE!" : ""}</div>
          {renderWinners(rbs)}
        </div>
        <br />
        <div>
          <div>High Receiver{wrs.length > 1 ? " - TIE!" : ""}</div>
          {renderWinners(wrs)}
        </div>
        <br />
        <div>
          <div>High Points{points.length > 1 ? " - TIE!" : ""}</div>
          {renderPointWinners(points)}
        </div>
      </>
    );
  };

  const createSeasonEmail = () => {
    if (!seasonWinners || seasonWinners.length === 0) {
      return <></>
    }
    const qbs = seasonWinners.filter((winner) => winner.Position === "QB");
    const rbs = seasonWinners.filter((winner) => winner.Position === "RB");
    const wrs = seasonWinners.filter((winner) => winner.Position === "WR");
    const points = seasonWinners.filter(
      (winner) => winner.Position === "Total Points"
    );

    const new_qb_leader = qbs.filter((qb) => qb.Week === week);
    const new_rb_leader = rbs.filter((rb) => rb.Week === week);
    const new_wr_leader = wrs.filter((wr) => wr.Week === week);
    const new_points_leader = points.filter((team) => team.Week === week);

    return (
      <>
        <div>{year} Season Leaders</div>
        <br />
        <div>
          <div>
            High Passer{qbs.length > 1 ? " - TIE!" : ""}
            {new_qb_leader.length > 0 && week !== 1 ? " - NEW SEASON LEADER" : ""}
          </div>
          {renderWinners(qbs)}
        </div>
        <br />
        <div>
          <div>
            High Rusher{rbs.length > 1 ? " - TIE!" : ""}
            {new_rb_leader.length > 0 && week !== 1 ? " - NEW SEASON LEADER" : ""}
          </div>
          {renderWinners(rbs)}
        </div>
        <br />
        <div>
          <div>
            High Receiver{wrs.length > 1 ? " - TIE!" : ""}
            {new_wr_leader.length > 0 && week !== 1 ? " - NEW SEASON LEADER" : ""}
          </div>
          {renderWinners(wrs)}
        </div>
        <br />
        <div>
          <div>
            High Points{points.length > 1 ? " - TIE!" : ""}
            {new_points_leader.length > 0 && week !== 1 ? " - NEW SEASON LEADER" : ""}
          </div>
          {renderPointWinners(points)}
        </div>
        <br />
      </>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">Draft Email - {year} Season through Week {week}</DialogTitle>
      <DialogContent>
          <Box sx={{ fontSize: 'small', fontFamily: 'Arial, Helvetica, sans-serif', lineHeight: '1.5', color: 'black'}}>
          {loading && <Skeleton animation="wave" variant="rectangular" />}

          {!loading && createSeasonEmail()}
          {!loading && (
            <div>
              ------------------------------------------------------------------
            </div>
          )}
          {!loading && createWeekEmail()}
          </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
